import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Controller, useFormContext } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

interface RadioInputListsProps {
    name: string;
    fullWidth?: boolean;
    options: Array<{ label: string; value: string; disabled?: boolean }>;
    styles?: React.CSSProperties;
}

const RadioWrapper = styled(FormControl)<{ styles?: React.CSSProperties }>(({ theme, styles }) => ({
    '& .label': {
        marginBottom: '16px',
        color: theme.palette.secondary.main,

        '& .required': {
            color: theme.palette.error.main,
        },

        '&.Mui-focused': {
            color: theme.palette.secondary.main,
        },
    },
    '&.Mui-focused': {
        color: theme.palette.secondary.main,
    },
    '& .radio-label': {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 500,
        color: theme.palette.secondary.main,
    },
    '& .radio-group': {
        gap: '40px',
        display: 'flex',
        flexDirection: 'row',
    },
    '& .MuiFormControlLabel-root': {
        marginRight: '0px',
    },
    ...styles,
}));

const RadioInputLists: React.FC<RadioInputListsProps> = ({ name, fullWidth = false, options, styles }) => {
    const { control } = useFormContext();

    return (
        <RadioWrapper fullWidth={fullWidth} styles={styles}>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <RadioGroup
                        {...field}
                        row
                        className="radio-group"
                        value={field.value || ''}
                        onChange={e => field.onChange(e.target.value)}>
                        {options.map(option => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                                disabled={option.disabled}
                                className="radio-label"
                            />
                        ))}
                    </RadioGroup>
                )}
            />
        </RadioWrapper>
    );
};

export default RadioInputLists;
